const _temp0 = require("../../app/components/lookbook/display_options/field/component.js");

const _temp1 = require("../../app/components/lookbook/embed/inspector/component.js");

const _temp2 = require("../../app/components/lookbook/nav/item/component.js");

const _temp3 = require("../../app/components/lookbook/params/field/component.js");
const _temp4 = require("../../app/components/lookbook/params/editor/component.js");

module.exports = {
  "display_options":   {
    "field": _temp0
  },
  "embed":   {
    "inspector": _temp1
  },
  "nav":   {
    "item": _temp2
  },
  "params":   {
    "field": _temp3,
    "editor": _temp4
  }
}